export default __webpack_public_path__ + "locales/failure.bua.json";